export const GET_PRATICAL_SHEETS = "GET_PRATICAL_SHEETS";
export const SAVE_PRATICAL_SHEETS = "SAVE_PRATICAL_SHEETS";
export const SEARCH_SHEETS = "SEARCH_SHEETS";

export const getPraticalSheets = () => ({
	type: GET_PRATICAL_SHEETS
});

export const savePraticalSheets = (sheets) => ({
	type: SAVE_PRATICAL_SHEETS,
	sheets
});

export const searchSheets = (sheetsValue) => ({
	type: SEARCH_SHEETS,
	sheetsValue
});